module.exports = __webpack_public_path__ + "static/img/pa.94225ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/pa.png
// module id = q20v
// module chunks = 18